export default __webpack_public_path__ + "static/media/ic_Flag_48px.253ff6c0.svg";